<template>
    <div class="card-body">
        <form>
            <div class="form-group">
                <label for="name">Name</label>
                <input type="text" class="form-control"   v-model="formData.name">
            </div>
            <div class="form-group">
                <label for="title">Title</label>
                <input type="text" class="form-control"   v-model="formData.title">
            </div>
            <div class="form-group">
                <label for="linkedin">Linkedin</label>
                <input type="text" class="form-control"   v-model="formData.linkedin">
            </div>
            <div class="form-group">
                <label for="twitter">Twitter</label>
                <input type="text" class="form-control" id="twitter"  v-model="formData.twitter">
            </div>
        </form>
         <button type="submit" class="btn btn-primary" @click="submitFunction(formData)">Submit</button>
    </div>
</template>

<script>
export default {

    props: {
        user: {
            type: Object
        },
        submitFunction: {
            type: Function
        }
    },
    data(){
        return{
            formData:{
                id: this.user.id,
                name: this.user.name,
                title: this.user.title,
                linkedin: this.user.linkedin,
                twitter: this.user.twitter
            }
        }
    }
}
</script>
